export class ImpactAssessmentColumnModel {
  id: boolean;
  regulator: boolean;
  title: boolean;
  ruleTopic: boolean;
  publishDate!: boolean;
  ruleType: boolean;
  applicationDate: boolean;
  legalEntity: boolean;
  jurisdiction: boolean;
  impactRating: boolean;
  implementationType: boolean;
  assessmentTeam: boolean;
  assessor: boolean;
  reviewTeam: boolean;
  reviewer: boolean;
  implementationTeam: boolean;
  implementationOwner: boolean;
  assessmentStatus: boolean;
  assessmentDueDate: boolean;
  reviewStatus: boolean;
  reviewDueDate: boolean;
  implementationStatus: boolean;
  implementationDueDate: boolean;

  constructor() {
    this.id = true;
    this.regulator = true;
    this.title = true;
    this.ruleTopic = true;
    this.ruleType = true;
    this.applicationDate = true;
    this.legalEntity = true;
    this.jurisdiction = true;
    this.assessmentTeam = true;
    this.assessor = true;
    this.assessmentDueDate = true;
    this.assessmentStatus = true;
    this.impactRating = true;
    this.implementationType = true;
    this.reviewTeam = true;
    this.reviewer = true;
    this.reviewDueDate = true;
    this.reviewStatus = true;
    this.implementationTeam = true;
    this.implementationOwner = true;
    this.implementationDueDate = true;
    this.implementationStatus = true;
  }
}
export class ImpactAssessmentColumnModelT6 {
  id: boolean;
  regulator: boolean;
  title: boolean;
  ruleTopic: boolean;
  publishDate!: boolean;
  ruleType: boolean;
  applicationDate: boolean;
  legalEntity: boolean;
  jurisdiction: boolean;
  impactRating: boolean;
  implementationType: boolean;
  assessmentTeam: boolean;
  assessor: boolean;
  reviewTeam: boolean;
  reviewer: boolean;
  implementationTeam: boolean;
  implementationOwner: boolean;
  assessmentStatus: boolean;
  assessmentDueDate: boolean;
  reviewStatus: boolean;
  reviewDueDate: boolean;
  implementationStatus: boolean;
  implementationDueDate: boolean;

  constructor() {
    this.id = true;
    this.regulator = true;
    this.title = true;
    this.ruleTopic = true;
    this.ruleType = true;
    this.applicationDate = true;
    this.legalEntity = true;
    this.jurisdiction = true;
    this.assessmentTeam = true;
    this.assessor = true;
    this.assessmentDueDate = true;
    this.assessmentStatus = true;
    this.impactRating = true;
    this.implementationType = true;
    this.reviewTeam = true;
    this.reviewer = true;
    this.reviewDueDate = true;
    this.reviewStatus = true;
    this.implementationTeam = true;
    this.implementationOwner = true;
    this.implementationDueDate = true;
    this.implementationStatus = true;
  }
}

